<template>
  <div id="type_box">
    <el-row>
      <el-col :span="18">
        <el-table :data="typeList" stripe highlight-current-row @current-change="typeListChange" style="width: 100%"
          height="700">
          <el-table-column prop="id" label="ID" width="55"></el-table-column>
          <el-table-column prop="name" label="分类名称"></el-table-column>
          <el-table-column label="是否严重">
            <template slot-scope="scope">
              {{scope.row.classType|objectsTypeClassToStr}}
            </template>
          </el-table-column>
          <el-table-column prop="description" label="备注"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="6">
        <el-form label-width="80px">
          <el-form-item label="分类名称">
            <el-input v-model="depForm.name"></el-input>
          </el-form-item>
          <el-form-item label="是否严重">
            <el-switch style="display: block" v-model="depForm.classType" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="depForm.description" style="width: 200px;" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="success" @click="goSave">{{saveTxt}}</el-button>
            <el-button type="danger" @click="goDel">{{delTxt}}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

  </div>
</template>
<script>
  export default {
    mixins: [require("@/mymixins").default],
    data() {
      return {
        typeList: [],
        depForm: {
          name: "",
          classType: 0,
          description: ""
        },
        nowId: 0,
        saveTxt: "新增",
        delTxt: "清空"
      }
    },
    filters: {
      objectsTypeClassToStr: function (value){
        if(value == 1){ return "是"; } else { return "否"; }
      }
    },
    mounted() {
      this.getTypeList();
    },
    methods: {
      initForm(){
        this.nowId = 0;
        this.saveTxt = "新增";
        this.delTxt = "清空";
        this.depForm = {
          name: "",
          classType: "1",
          description: "",
        };
        this.getTypeList();
      },
      goSave(){
        let url = "";
        let tempData = this.depForm;
        if(this.nowId){
          //修改
          tempData.id = this.nowId;
          url = "api/patient/type/modify";
        } else {
          //新增
          url = "api/patient/type/add";
        }
        this.post(url, tempData).then(res => {
          if(res.success == true){
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          } else {
            this.$message.error(res.detail);
          }
          this.initForm();
        });
      },
      goDelete(){
        if(this.nowId){
          //删除
          this.post("api/patient/type/remove", [this.nowId]).then(res => {
            if(res.success == true){
              this.$message({
                message: '删除成功',
                type: 'success'
              });
            } else {
              this.$message.error(res.detail);
            }
          });
        }
        this.initForm();
      },
      goDel(){
        if(this.delTxt == "清空"){
          this.initForm();
        } else {
          this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.goDelete();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消删除'
            });
            this.initForm();
          });
        }
      },
      typeListChange(val) {
        if(val){
          this.depForm.name = val.name;
          this.depForm.classType = val.classType;
          this.depForm.description = val.description;
          this.nowId = val.id;
          this.saveTxt = "修改";
          this.delTxt = "删除";
        }

      },
      getTypeList() {
        this.get("api/patient/type/list", {}).then(res => {
          //console.log(res);
          this.typeList = res.data;
        });
      }
    }
  }
</script>
<style lang="scss">
  #type_box {
    width: 1100px;
  }
</style>
